import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import { JOB_STATUSES } from './constants';

dayjs.extend(customParseFormat);
dayjs.extend(utc);

export const CHAT_POST_SHIFT_HOURS = 48;

export const CHAT_POST_SHIFT_NOTE =
  "Haven't received payment yet? You can message through the in-app chat for 48 hours after the shift.";

const getShiftEndMs = (job: any): number | null => {
  const shift = job?.shifts?.[0] ?? job?.shift;
  if (!shift) return null;
  const status = Number(job?.status);
  const selectedEnd = status === JOB_STATUSES.COMPLETED && shift.actualEnd
    ? shift.actualEnd
    : shift.postedEnd;
  if (selectedEnd == null || selectedEnd === '') return null;
  const endRaw = String(selectedEnd);
  if (/\d{4}-\d{2}-\d{2}/.test(endRaw)) {
    const parsed = dayjs.utc(endRaw);
    return parsed.isValid() ? parsed.valueOf() : null;
  }
  const datePart = job?.startDate || shift?.shiftDate;
  if (!datePart) return null;
  const combinedStr = `${String(datePart).substring(0, 10)} ${endRaw}`;
  const formats = ['YYYY-MM-DD h:mm a', 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm'];
  for (const format of formats) {
    const parsed = dayjs.utc(combinedStr, format, true);
    if (parsed.isValid()) return parsed.valueOf();
  }
  const fallback = dayjs.utc(combinedStr);
  return fallback.isValid() ? fallback.valueOf() : null;
};

const getChatCloseMs = (job: any): number | null => {
  const shift = job?.shifts?.[0] ?? job?.shift;
  if (!shift) return null;

  if (shift.chatClosesAtUtc) {
    const parsed = dayjs.utc(shift.chatClosesAtUtc);
    return parsed.isValid() ? parsed.valueOf() : null;
  }

  const endMs = getShiftEndMs(job);
  return endMs == null
    ? null
    : dayjs.utc(endMs).add(CHAT_POST_SHIFT_HOURS, 'hour').valueOf();
};

/** T2-6345: shift chat is open while booked or up to 48h after shift end (UTC). */
export const isShiftChatOpen = (job: any): boolean => {
  if (!job) return false;
  const status = Number(job.status);
  if (status === JOB_STATUSES.CONFIRMED) return true;
  if (status === JOB_STATUSES.COMPLETED) {
    const chatCloseMs = getChatCloseMs(job);
    return chatCloseMs != null && chatCloseMs >= Date.now();
  }
  return false;
};

export const shouldShowPostShiftChatNote = (job: any): boolean =>
  Number(job?.status) === JOB_STATUSES.COMPLETED && isShiftChatOpen(job);
